import React, { useEffect } from 'react'
import { useUIStore } from '../../store/uiStore'
import { SearchBar } from '../molecules/SearchBar'
import { useFocusTrap } from '../../hooks/useFocusTrap'

export const SearchOverlay: React.FC = () => {
  const { searchOpen, closeSearch } = useUIStore()
  const containerRef = useFocusTrap(searchOpen) as React.RefObject<HTMLDivElement>

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeSearch()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [closeSearch])

  if (!searchOpen) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Search"
      className="fixed inset-0 z-50 bg-charcoal/60 flex items-start justify-center pt-24 px-4"
      onClick={(e) => { if (e.target === e.currentTarget) closeSearch() }}
    >
      <div
        ref={containerRef}
        className="w-full max-w-2xl bg-white rounded-sm shadow-elevation-3 p-4 animate-slide-up"
      >
        <div className="flex items-center justify-between mb-3">
          <p className="text-body-base font-semibold text-charcoal">Search Products</p>
          <button
            onClick={closeSearch}
            aria-label="Close search"
            className="
              w-8 h-8 flex items-center justify-center rounded-sm
              text-dark-gray hover:text-charcoal
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royal-orange
            "
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <SearchBar autoFocus onClose={closeSearch} />
      </div>
    </div>
  )
}